import { useState, useEffect } from "react";

export default function ServerDownPopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener("api-server-down", handler);
    return () => window.removeEventListener("api-server-down", handler);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[99999] bg-black/45 flex items-center justify-center">
      <div className="bg-white rounded-[14px] py-9 px-10 max-w-[420px] w-[90%] text-center shadow-[0_8px_40px_rgba(0,0,0,0.18)]">
        <div className="text-5xl mb-3">🚫</div>
        <h2 className="m-0 mb-2 text-xl font-bold text-slate-800">
          API Server is Down
        </h2>
        <p className="m-0 mb-6 text-sm text-slate-500 leading-relaxed">
          The server is temporarily unavailable (503).<br />
          Please wait a moment and try again.
        </p>
        <button
          onClick={() => setVisible(false)}
          className="bg-[#6c5ffc] text-white border-none rounded-lg py-2.5 px-7 text-sm font-semibold cursor-pointer"
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}